export default __webpack_public_path__ + "static/media/Rabi_2022-23.a045255e.webm";